import {News, NewsService as NewsServiceAPI, NotificationService} from 'kkm-library';
import {Injectable, inject, signal} from '@angular/core';
import {lastValueFrom, retry} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NewsService {
    private newService = inject(NewsServiceAPI);
    private notification = inject(NotificationService);

    constructor() {
        this.initNews();
    }

    newsListe = signal<News[]>([]);
    isLoading = signal(true);

    private async initNews(): Promise<void> {
        this.newsListe.set(await lastValueFrom(this.newService.getAllNews().pipe(retry(5))));
        this.isLoading.set(false);

        if (this.newsListe().length == 0) {
            const news = this.newNews();
            news.betreff = 'Keine News verfügbar';
            this.newsListe.set([news]);
        }
        return;
    }

    newNews(): News {
        return {
            id: 0,
            betreff: '',
            datum: new Date(),
            bilder: [],
        };
    }

    speichern(news: News): News {
        // Anlegen
        const promise =
            news.id === 0
                ? lastValueFrom(this.newService.newNewsEntry(news))
                : lastValueFrom(this.newService.editNewsEntry(news.id, news));

        promise.then(response => {
            this.changeListe(response);
            this.notification.success('Gespeichert');
            return response;
        }, this.handleError);

        console.log('Nope');

        return news;
    }

    delete(news: News): void {
        if (news.id)
            lastValueFrom(this.newService.deleteNewsEntry(news.id)).then(response => {
                this.removeNews(response);
                this.notification.success('Eintrag gelöscht');
            }, this.handleError);
    }

    private handleError = (error: {error: {message: string}}) => {
        this.notification.error(`Beim Speichern ist ein Fehler aufgetreten. ${error.error.message}`);
    };

    private changeListe(news: News): void {
        this.newsListe.update(list => {
            const existingTaskIndex = list.findIndex(i => i.id === news.id);
            if (existingTaskIndex !== -1) {
                list[existingTaskIndex] = news;
            } else {
                list.push(news);
            }
            return list.slice(0);
        });
    }

    private removeNews(news: News): void {
        this.newsListe.update(list => {
            const existingTaskIndex = list.findIndex(i => i.id === news.id);
            if (existingTaskIndex !== -1) {
                list.splice(existingTaskIndex, 1);
            }
            return list.slice(0);
        });
    }
}
